import { useEffect, useState, useRef, useContext } from "react";
import './homepage.scss';
import Crystal from "../../Components/Scene/Crystal";
import ScrollTracker from "../../Components/ScrollTracker/ScrollTracker";
import ScrollText from "../../Components/ScrollText/ScrollText";
import Skills from "../../Components/Skills/Skills";
import AboutMe from "../../Components/AboutMe/AboutMe";
import Experience from "../../Components/Experience/Experience";
import Projects from "../../Components/Projects/Projects";
import Contact from "../../Components/Contact/Contact";
import ScrollTopContext from "../../Contexts/ScrollTop";
import Footer from "../../Components/Footer/Footer";
import Language from "../../Components/Language/Language";
import Theme from "../../Components/Theme/Theme";
import Sound from "../../Components/Sound/Sound";

export function findNewHeight() {
  const defaultHeight = 7453;
  const currentZoom = window.outerWidth / window.innerWidth;
  const allowedZooms = [1.1, 1, 0.9, 0.8, 0.75, 0.67, 0.5, 0.33, 0.25];
  const fixedZoom = allowedZooms.reduce((prev, curr) => 
    Math.abs(curr - currentZoom) < Math.abs(prev - currentZoom) ? curr : prev
  );
  return defaultHeight / fixedZoom;
}

const Homepage = () =>{
    const homepageContainer = useRef<HTMLDivElement>(null);
    const [currentScrollTop, setCurrentScrollTop]= useState(0);
    const [maxScrollValue, setMaxScrollValue] = useState(0);
    const {scrollTop, setScrollTop} = useContext(ScrollTopContext);
    const [currentHeight, setCurrentHeight] = useState(7453);

    useEffect(() =>{
      if(scrollTop !== 0){
        homepageContainer.current?.scrollTo({
          top: (scrollTop / 7453) * currentHeight || 0, 
          behavior: 'smooth'
        });
        setScrollTop(0);
      }
      if(scrollTop === -1){
        homepageContainer.current?.scrollTo({
          top: 0, 
          behavior: 'smooth'
        });
        setScrollTop(0);
      }
    },[scrollTop, currentHeight])

    useEffect(() => {
        const handleScroll = () => {
          if (homepageContainer.current && homepageContainer.current.scrollTop !== 0) {
            setCurrentScrollTop(homepageContainer.current.scrollTop)
          } 
          else{
            setCurrentScrollTop(0)
          }
        };

        homepageContainer.current?.addEventListener("scroll", handleScroll);
        return () => {
            homepageContainer.current?.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() =>{
      if(homepageContainer.current){
        setMaxScrollValue(homepageContainer.current.scrollHeight - homepageContainer.current.clientHeight)
        if(homepageContainer.current?.scrollTop > 0){
          localStorage.setItem("moved", "true")
        }
        else{
          localStorage.setItem("moved", "false")
        }
      }
    },[homepageContainer.current?.scrollTop])

    useEffect(() => {
      function reSize() {
        
        const newHeight = findNewHeight(); 

        if (homepageContainer.current) {
          const prevHeight = currentHeight;
          const prevScroll = homepageContainer.current.scrollTop;
          const scrollRatio = prevScroll / prevHeight;

          setCurrentHeight(newHeight); 
            homepageContainer.current?.scrollTo({
            top: scrollRatio * newHeight, 
            behavior: 'auto'
          });
        }
      }

      reSize();
      window.addEventListener("resize", reSize);
      return () => {
        window.removeEventListener("resize", reSize);
      };
    }, [currentHeight]);

    useEffect(() => {
      function focus() {
        if(homepageContainer.current){
          homepageContainer.current.focus();
        }
      }

      focus();
      window.addEventListener("wheel", focus);
      return () => {
        window.removeEventListener("wheel", focus);
      };
    }, [currentHeight]);


    return(
        <div className="homepage">
            <div className="background-model" style={{ pointerEvents: "none" }}>
                {true && <Crystal currentScrollTop={currentScrollTop / 7453 * currentHeight}/>}
            </div>
            <div ref={homepageContainer} className="homepage-container" id="homepage-container" tabIndex={-1}> 
                <ScrollTracker maxValue={maxScrollValue} currentValue={currentScrollTop}/>
                <ScrollText scrollTop={currentScrollTop}/>
                <AboutMe scrollTop={currentScrollTop > 0 && currentScrollTop < 350 ? currentScrollTop : 0} height={(1900 / 7453) * currentHeight}/>
                <Skills scrollTop={currentScrollTop > 1300 ? currentScrollTop : 0} height={(1400 / 7453) * currentHeight}/>
                <Experience scrollTop={currentScrollTop} height={(1400 / 7453) * currentHeight}/>
                <Projects scrollTop={currentScrollTop > 3750 ? currentScrollTop : 0} height={(1400 / 7453) * currentHeight}/>
                <Contact scrollTop={currentScrollTop} height={(1270 / 7453) * currentHeight}/>
                <Footer height={(85 / 7453) * currentHeight}/>
                <Language/>
                <Theme/>
                <Sound/>
            </div>
        </div>
    )
}
export default Homepage